export function loadGoogleMapsScript(): Promise<void> {
  const googleMapsKey = import.meta.env.VITE_GOOGLEMAPS_KEY

  return new Promise((resolve, reject) => {
    if (document.getElementById('google-maps-script')) {
      resolve()
      return
    }

    ;(window as never).initMap = () => {
      resolve()
    }

    const script = document.createElement('script')
    script.id = 'google-maps-script'
    script.src = `https://maps.googleapis.com/maps/api/js?key=${googleMapsKey}&libraries=visualization,geometry&callback=initMap&language=pt-BR&region=BR`
    script.async = true
    script.defer = true
    script.onerror = reject
    document.head.appendChild(script)
  })
}
